const cursor = {
  name: "cursor",
  path: "/cursor",
  title: "cursor",
  description: "Utilities for controlling the CSS cursor property.",
  value: {
    "cursor": {
      "cursor-auto": "auto",
      "cursor-default": "default",
      "cursor-pointer": "pointer",
      "cursor-wait": "wait",
      "cursor-text": "text",
      "cursor-move": "move",
      "cursor-help": "help",
      "cursor-not-allowed": "not-allowed",
      "cursor-none": "none",
      "cursor-context-menu": "context-menu",
      "cursor-progress": "progress",
      "cursor-cell": "cell",
      "cursor-crosshair": "crosshair",
      "cursor-alias": "alias",
      "cursor-copy": "copy",
      "cursor-grab": "grab",
      "cursor-grabbing": "grabbing",
      "cursor-zoom-in": "zoom-in",
      "cursor-zoom-out": "zoom-out",
      "cursor-no-drop": "no-drop",
      "cursor-all-scroll": "all-scroll",
      "cursor-col-resize": "col-resize",
      "cursor-row-resize": "row-resize",
      "cursor-n-resize": "n-resize",
      "cursor-ne-resize": "ne-resize",
      "cursor-e-resize": "e-resize",
      "cursor-se-resize": "se-resize",
      "cursor-s-resize": "s-resize",
      "cursor-sw-resize": "sw-resize",
      "cursor-w-resize": "w-resize",
      "cursor-nw-resize": "nw-resize",
      "cursor-ew-resize": "ew-resize",
      "cursor-ns-resize": "ns-resize",
      "cursor-nesw-resize": "nesw-resize"
    }
  },
  exampleData: [
    {
      example: {
        code: `<button class="cursor-pointer px-4 py-2 border rounded">Pointer</button>
<button class="cursor-wait px-4 py-2 border rounded">Wait</button>
<button class="cursor-not-allowed px-4 py-2 border rounded" disabled>Not Allowed</button>`
      }
    }
  ],
  htmlData: [
    {
      title: "Cursor",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">cursor-*</code> utilities to control the mouse cursor style.
      </p>
      <div class="flex gap-4 flex-wrap">
        <button class="cursor-pointer px-4 py-2 border rounded">Pointer</button>
        <button class="cursor-wait px-4 py-2 border rounded">Wait</button>
        <button class="cursor-not-allowed px-4 py-2 border rounded" disabled>Not Allowed</button>
        <button class="cursor-grab px-4 py-2 border rounded">Grab</button>
        <button class="cursor-crosshair px-4 py-2 border rounded">Crosshair</button>
      </div>
      `
    }
  ]
};

export default cursor;
<div class="flex gap-4 flex-wrap sr-only">
        <button class="cursor-pointer px-4 py-2 border rounded">Pointer</button>
        <button class="cursor-wait px-4 py-2 border rounded">Wait</button>
        <button class="cursor-not-allowed px-4 py-2 border rounded" disabled>Not Allowed</button>
        <button class="cursor-grab px-4 py-2 border rounded">Grab</button>
        <button class="cursor-crosshair px-4 py-2 border rounded">Crosshair</button>
      </div>